module.exports = __webpack_public_path__ + "static/media/11.ecb4b389.jpg";